import React, { FC } from 'react'
import Image from 'components/Artworks/Image/Basic'
import { getImageProps } from 'components/Artworks/Image/helpers'
import OriginalInfo from 'components/Artworks/Info/Original'
import { getInfoProps } from 'components/Artworks/Info/helpers'
import { DESKTOP_COLUMN_WIDTH, MOBILE_COLUMN_WIDTH, SPAN_HEIGHT } from '../../helpers/constants'

type ShowsArtworkProps = {
  shouldOpenNewDesktopPdpTab: boolean
  artwork: Record<string, any>
  hasPrints: boolean
  index: number
  isMobile: boolean
  lazyLoad: boolean
  priority: boolean
}

const ShowsArtwork: FC<ShowsArtworkProps> = (props) => {
  const { shouldOpenNewDesktopPdpTab, artwork, isMobile, lazyLoad, priority } = props

  if (!artwork) {
    return null
  }

  // We need to figure out Height/SPAN size of Image
  const { height, width } = artwork
  const aspectRatio = width / height
  const columnWidth = isMobile ? MOBILE_COLUMN_WIDTH : DESKTOP_COLUMN_WIDTH
  const imageHeight = parseInt(columnWidth / aspectRatio, 10)
  const imageSpanCount = Math.round(imageHeight / SPAN_HEIGHT)
  // Artwork info is a constant SPAN size
  const infoSpanCount = isMobile ? 5 : 6
  const totalSpanCount = imageSpanCount + infoSpanCount
  // Helpers to PASS only props NEEDED
  const dataProps = {
    dataApi: 'palette',
    dataList: 'shows-results',
  }
  const imageProps = getImageProps(props)
  const infoProps = getInfoProps(props)
  return (
    <figure
      style={{
        gridRowEnd: `span ${totalSpanCount}`,
      }}
    >
      <Image
        shouldOpenNewDesktopPdpTab={shouldOpenNewDesktopPdpTab}
        {...imageProps}
        {...dataProps}
        lazyLoad={lazyLoad}
        priority={priority}
        eventType='shows'
      />
      <OriginalInfo {...infoProps} shouldOpenNewDesktopPdpTab={shouldOpenNewDesktopPdpTab} />
    </figure>
  )
}

export default ShowsArtwork
